import styled from "styled-components/macro";
import { BREAK_ } from "constants";
import { MENU } from "constants";

export const Aside = styled.aside`
  background: ${({ clr, filter }) => filter ? `${clr?.primary}e6` : "transparent"};

  ${BREAK_.md_dn} {
    position: fixed;
   top: ${({ filter, iFrameEnabled }) =>
  iFrameEnabled ? "0px" : filter ? "69px" : "70px"};

    height: 100%;
    width: 100%;
    z-index: 55;
  }
  ${BREAK_.md_up} {
    z-index:55;
    height: ${({ filter, matches }) => ( filter ? "calc(100% - 180px)" : "100%")};
    max-height: ${({ filter }) => (filter ? `713px` : "100%")};
    width: ${({ w }) => w}px;
    min-width:${({mw})=>mw}px;
    position: fixed;
        ${({ filter,isIsometry, iFrameEnabled}) => (filter  ? { bottom: "106px" } : { top: iFrameEnabled ?"0px" : "72px" })};
    left: ${({ left, nav }) => (left ? 48 + "px" : "unset")};
    right: ${({ right }) => (right ? 0 : "unset")};
    opacity: 1;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`;
